/* eslint-disable no-shadow */
import useSWR from 'swr';

import { fetchModel } from 'src/store/api';

export default function useModel({ modelId, options = {}, config = { shouldFetch: true } }) {
  const { shouldFetch } = config;

  const url = `/core/v2/thinkalike_model/${modelId}`;
  const requestOptions = { ...options };

  return useSWR(shouldFetch ? { key: url, requestOptions } : null, ({ requestOptions: o }) => fetchModel(modelId, o), {
    revalidateIfStale: false,
    revalidateOnMount: false,
    revalidateOnFocus: false,
  });
}
